export default {
  elomark_users: [],
  elomark_role_types : [],
  autocomplete_data : [],
  autocomplete_selected : {},
  verticals : [],
  vertical_selected : {},
  countries : [],
  countries_selected : {},
  head_office_country_selected : {},
  elomark_user:[],
  selected_elomark_user : {},
  elomark_user_status:[],
  selected_campaign_manager : {},
  selected_sales_developer_1 : {},
  selected_sales_developer_2 : {},
  selected_sales_developer_3 : {},
  all_time_zone:[],
  all_languages:[],
  selected_time_zone:{},
  selected_language:{},
  campaign_associated_client_contact:[]
}
